export interface DeliveryRestriction {
  productid?: number;
  title?: string;
  regions?: string[];
  countries?: string[];
}

export function normalizeDeliveryCountry(value: unknown): string {
  const code = typeof value === 'string' ? value.trim().toUpperCase() : '';
  return code === 'UK' ? 'GB' : /^[A-Z]{2}$/.test(code) ? code : '';
}

export function incompatibleDelivery(rules: DeliveryRestriction[], country: unknown): DeliveryRestriction[] {
  const code = normalizeDeliveryCountry(country);
  return rules.filter(rule => !code || !Array.isArray(rule.countries) || !rule.countries.includes(code));
}
